export const getters = {
  getWidgetsRemaining(state) {
    return state.unrenderedWidgets?.size;
  },
  widgetsAreReadyToPaginate(state) {
    const readyToPaginate = Object.keys(state.readyToPaginateWidgets);
    const existsInQueue = readyToPaginate.filter((widgetId) =>
      Object.hasOwn(state.paginationQueue, widgetId)
    );

    const readyToPaginateCheck = readyToPaginate.sort().join(',');

    // check whether we've hit the pagination target and all the elements are in the DOM ready to go
    return (
      readyToPaginateCheck === Object.keys(state.paginationTargetList).sort().join(',') &&
      readyToPaginateCheck === existsInQueue.sort().join(',')
    );
  },
  isReadyToPaginate(state) {
    return state.isReadyToPaginate;
  },
  getNextWidgetToPaginate(state) {
    return Object.keys(state.readyToPaginateWidgets).at(0) ?? false;
  },
  hasNextWidgetToPaginate(state) {
    return Object.keys(state.readyToPaginateWidgets).length > 0;
  },
  getResourcesLoadingQueueLength(state) {
    return Object.keys(state.resourcesLoadingQueue).length;
  },
  getWidgetsToPaginate(state) {
    return Object.keys(state.readyToPaginateWidgets);
  },
  getFromPaginationQueue(state, widgetId) {
    return state.paginationQueue[widgetId];
  },
  paginationIsReadyToDisplay(state) {
    return state.measuredElementsCounter >= Object.keys(state.paginationTargetList).length;
  },
  getPaginationTargetForLayout(state, layoutId) {
    return state.paginationPerLayout[layoutId] ?? 0;
  },
  getIsReadyToDisplay(state) {
    return state.isReadyToDisplay;
  },
  getMeasuredElementsInLayout(state, layoutId) {
    return state.measuredElements[layoutId];
  },
  getMeasuredElements(state) {
    return Object.values(state.measuredElements).flat();
  },
  getExecutiveSummaryQueue(state) {
    return state.executiveSummaryQueue;
  },
};
